import React from 'react'
import { ApiHook } from '../../hooks/apiHook';
import { useNavigate, useParams } from 'react-router';
import CurrencyConverter from '../../Currency/CurrencyConverter';

const CourseDetails = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    const { data: courseDetail, isLoading } = ApiHook.CallCourseDetails(id);

    const handleBuyNow = (id) => {
        navigate(`/replica-register/${id}`);
    };

    const clickBack = () => {
        window.history.back();
    }
    return (
        <div className='m-5 px-5 py-2'>
            <div role="button" title="Back" onClick={clickBack} className='mb-3 pointer'><i class="fa-solid fa-arrow-left fa-2xl"></i></div>
            <div className='row'>
                <div className="col-md-6 col-sm-12">
                    <img className='w-100' style={{ height: '35rem', borderRadius: '20px' }} src={courseDetail?.data?.image || "https://cdn.elearningindustry.com/wp-content/uploads/2020/02/what-to-check-before-an-online-course-purchase.png"} alt="" />
                </div>
                <div className="col-md-6 col-sm-12">
                    <h2>{courseDetail?.data?.name || 'Name'}</h2>
                    <p className='pt-3'>{courseDetail?.data?.description}</p>
                    <div>
                        {courseDetail?.data?.price < courseDetail?.data?.actualPrice && <span className='text-decoration-line-through text-danger fs-5'>
                            {`${courseDetail?.data?.defaultCurrency?.symbolLeft
                                } ${CurrencyConverter(
                                    courseDetail?.data?.actualPrice,
                                    courseDetail?.data?.defaultCurrency
                                )}`}
                        </span>}
                        <span className='fw-bolder fs-2'>
                            {`${courseDetail?.data?.defaultCurrency?.symbolLeft
                                } ${CurrencyConverter(
                                    courseDetail?.data?.price,
                                    courseDetail?.data?.defaultCurrency
                                )}`}
                        </span>
                    </div>
                    <div className='course-buyBtn text-center mt-2' style={{ width: '12rem', fontSize: '1.3rem' }} onClick={() => handleBuyNow(courseDetail?.data?.id)}>Buy now</div>
                    {/* <div className='mt-3'>
                        <h3>Description</h3>
                        <p className='pt-3'>{courseDetail?.data?.description}</p>
                    </div> */}
                </div>
            </div>
        </div>
    )
}

export default CourseDetails